//=> Import React
import React from "react"

//=> Import component
import Layout from "../component/Layout"
import HeaderAcceuil from "../component/HeaderAcceuil"
import Presentation from "../component/Presentation"
import Footer from "../component/Footer"
import SEO from '../component/SEO'



//=> Component
const IndexPage = () => {

  return (
    <Layout>
      <SEO title={"Accceuil"} />
      <HeaderAcceuil />
      <div style={{ minHeight: "calc(100vh - 333.11px)", backgroundColor: "#fff" }}>
        <Presentation />
      </div>

      <Footer />
    </Layout>
  )
}


export default IndexPage
